export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm-.607 3.047a.75.75 0 0 1 .75.75v5.18l3.76 2.39.062.045a.75.75 0 0 1-.8 1.259l-.067-.037-4.108-2.613-.347-.22V7.297a.75.75 0 0 1 .75-.75Z"/>
</svg>
`;
